import api from '../config/api';
import {
  UGCDraftResponse,
  UGCDraftsListResponse,
  UGCFormState,
  UGCDraftStatus,
} from '../models/ugc-draft/types';

export const updateStatusUrlMap = {
  active: 'restore',
  submitted: 'submit',
  archived: 'archive',
} as const;

class UGCDraftService {
  id: number | undefined;

  constructor(id: number | undefined) {
    this.id = id;
  }

  static index = () => {
    return api.get<UGCDraftsListResponse>('/ugc_drafts');
  };

  fetch = () => {
    return api.get<UGCDraftResponse>(`/ugc_drafts/${this.id}`);
  };

  create = (data: UGCFormState) => {
    return api.post<UGCDraftResponse>('/ugc_drafts', data);
  };

  update = (data: UGCFormState) => {
    return api.put<UGCDraftResponse>(`/ugc_drafts/${this.id}`, data);
  };

  updateStatus = (status: UGCDraftStatus) => {
    const path = `/ugc_drafts/${this.id}/${updateStatusUrlMap[status]}`;

    return api.post<UGCDraftResponse>(path);
  };
}

export default UGCDraftService;
